import { Component, OnInit, Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TareasService, TareaModel } from 'src/app/services/tareas.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  CasoTareaModel,
  CasoTareaService,
} from 'src/app/services/casos_tareas.service';
import {
  TareaCasoService,
  TareaCasoModel,
} from 'src/app/services/tareacaso.service';

@Component({
  selector: 'agregar-tareas',
  templateUrl: './agregar-tareas.component.html',
  styleUrls: ['./agregar-tareas.component.scss'],
})
export class AgregarTareasComponent implements OnInit {
  caso: CasoTareaModel = null;
  search: string = '';
  tareas: TareaModel[] = null;
  tareasOriginal: TareaModel[] = [];
  tipo_caso: string = '';

  taskSelected = [];

  constructor(
    public _tareas: TareasService,
    public _caso: CasoTareaService,
    public _tareacaso: TareaCasoService,
    public dialogRef: MatDialogRef<AgregarTareasComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CasoTareaModel,
    private _snackBar: MatSnackBar
  ) {}

  close() {
    this.dialogRef.close();
  }

  addToSelected(task: TareaModel) {
    this.tareas = this.tareas.filter((tarea) => tarea._id !== task._id);
    this.taskSelected.push(task);
  }

  removeFromSelected(task: TareaModel) {
    this.taskSelected = this.taskSelected.filter(
      (tarea) => tarea._id !== task._id
    );
    this.tareas.push(task);
  }

  ngOnInit() {
    this.caso = this.data;
    this.tipo_caso = this.data.tipo_caso;

    // Obteniendo las tareas por unidad
    this._tareas
      .getByTipoCaso(this.tipo_caso)
      .subscribe((tareas: TareaModel[]) => {
        // Creando propiedad checked para las tareas y sus checkboxes
        for (let i in tareas) tareas[i].checked = false;

        // Habilitar checkbox de tareas con campo requerido activado
        tareas.map((tarea) => {
          if (tarea.requerido) {
            this.changeCheck({ checked: true }, tarea);
          }
        });

        this.obtenerTareasSeleccionadas();
      });
  }

  obtenerTareasSeleccionadas() {
    this._tareas
      .getByTipoCaso(this.tipo_caso)
      .subscribe((tareas: TareaModel[]) => {
        // Filtra las tareas para que ninguna sea requerida
        tareas = tareas.filter((tarea: TareaModel) => tarea.requerido != true);

        this.tareas = tareas;
        this._tareacaso
          .getByCaso(this.data._id)
          .subscribe((response: TareaCasoModel) => {
            for (let i in response) {
              // Habilitando los checkboxes de las tareas actuales
              var indexg: number;
              const tarea = this.tareas.find((tarea, index) => {
                indexg = index;
                return tarea._id === response[i].idTarea;
              });
              if (tarea) {
                tarea.checked = true;
                if (!tarea.checked && tarea) this.tareas[indexg] = tarea;
                else {
                  this.tareas.splice(indexg, 1);
                  this.deleteTareaFromArray(tarea.titulo);
                }
              }
            }
          });
      });
  }

  deleteTareaFromArray(titulo: string) {
    this.tareas = this.tareas.filter((tarea: TareaModel) =>
      tarea.titulo !== titulo ? true : false
    );
    this.tareasOriginal = this.tareasOriginal.filter((tarea: TareaModel) =>
      tarea.titulo !== titulo ? true : false
    );
  }

  async changeCheck(event: any, tarea: TareaModel) {
    if (event.checked) {
      this.caso.historial.push({
        usuario: `${sessionStorage.getItem('correo')}`,
        realizo: `Agrego la tarea "${tarea.titulo}" a la columna "Pendiente por realizar"`,
        date: new Date(),
      });
      const tareacaso = await this._tareacaso
        .post({
          idTarea: tarea._id,
          idCaso: this.data._id,
          estado: 'Pendiente de realizar',
          deleted: false,
        })
        .toPromise();
      console.log(tareacaso);
      if (
        tareacaso.msj !== 'La tarea ya esta asociada al caso' &&
        !tarea.requerido
      )
        this.openSnackBar(tareacaso.msj, 'x');
      if (tareacaso.msj === 'Tarea agregada al caso')
        await this._caso.put(this.caso._id, this.caso).toPromise();
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action);
  }

  addTasks() {
    this.taskSelected.map(async (task) => {
      await this.changeCheck({ checked: true }, task);
    });
    this.dialogRef.close();
  }

  filter() {
    if (this.tareasOriginal.length === 0) this.tareasOriginal = this.tareas;
    this.tareas = this.tareasOriginal;
    this.tareas = this.tareas.filter(
      (tarea) =>
        JSON.stringify(tarea)
          .toLowerCase()
          .indexOf(this.search.toLowerCase()) !== -1
    );
  }
}
